import styled from 'styled-components';
import { Link } from 'react-router-dom';
import type { PtoRdRevision } from '@shared/api';
import { Button } from '@shared/ui/Button';
import { Muted } from './styles';

const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(3)};
  margin-bottom: ${({ theme }) => theme.spacing(4)};
`;

const Title = styled.h1`
  margin: 0;
  font-size: 22px;
`;

/** Шифр комплекта и ревизия под заголовком. */
const Complect = styled.div`
  margin: 2px 0;
  font-size: 14px;
  overflow-wrap: anywhere;
`;

const Code = styled.span`
  font-weight: 600;
`;

interface Props {
  projectId: string;
  /** Шифр комплекта (документа РД); null — не загружен. */
  docCode: string | null;
  /** Ревизия экрана; null — не загружена. */
  revision: Pick<PtoRdRevision, 'revision_no' | 'rev_label' | 'status'> | null;
  /** Всего позиций ревизии (без фильтра). */
  total: number;
  tableCount: number;
  reviewCount: number;
}

/** «ревизия 2 (Изм.1) · действующая» — как в реестре РД проекта; в начале строки —
 *  с заглавной. */
function revisionCaption(r: NonNullable<Props['revision']>, first: boolean): string {
  return `${first ? 'Ревизия' : 'ревизия'} ${r.revision_no}${r.rev_label ? ` (${r.rev_label})` : ''} · ${
    r.status === 'active' ? 'действующая' : 'заменена'
  }`;
}

/** Шапка экрана: название, шифр комплекта и ревизия, счётчики позиций ревизии и
 *  возврат к проекту. */
export function VolumesHeader({
  projectId,
  docCode,
  revision,
  total,
  tableCount,
  reviewCount,
}: Props) {
  return (
    <Head>
      <div>
        <Title>Позиции объёма и входной контроль РД</Title>
        {(docCode || revision) && (
          <Complect>
            {docCode && <Code>{docCode}</Code>}
            {docCode && revision ? ' · ' : ''}
            {revision && revisionCaption(revision, !docCode)}
          </Complect>
        )}
        <Muted>
          Извлечены из ревизии РД · всего {total}
          {tableCount > 0 ? ` · из таблиц ${tableCount}` : ''}
          {reviewCount > 0 ? ` · замечаний входного контроля ${reviewCount}` : ''}
        </Muted>
      </div>
      <Link to={`/agents/pto/${projectId}`}>
        <Button $variant="secondary">← К проекту</Button>
      </Link>
    </Head>
  );
}
